<template>
    <el-card>
        <div slot="header" class="checklist header">
            <img src="../image/checklist_new.png" class="header-icon">
            <span class="header-title">Checklists</span>
        </div>
        <ChecklistTable :patient="patient" :checklists="checklists"></ChecklistTable>
    </el-card>
</template>

<script>
import OverviewCard from '..'

import ChecklistTable from './Table'

export default {
    name: 'patient-checklist-card',
    extends: OverviewCard,

    computed: {
        checklists() {
            return this.patientEventType('checklist')
        }
    },

    components: {
        ChecklistTable
    }
}
</script>

<style lang="scss">
@import "../style.scss";
</style>
